"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessages = exports.classes = exports.InputTextTypes = exports.InputSizes = void 0;
var InputSizes = {
  "default": 'default',
  small: 'small'
};
exports.InputSizes = InputSizes;
var InputTextTypes = ['number', 'date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'time', 'text', 'url', 'week'];
exports.InputTextTypes = InputTextTypes;
var base = 'luna-form_control';
var wrapperBase = "".concat(base, "-text");
var inputBase = "".concat(base, "--input");
var affixBase = "".concat(base, "--affix");
var affixSelect = "".concat(base, "--affix_select");
var classes = {
  base: base,
  input: {
    base: inputBase,
    populated: "".concat(inputBase, "-is_populated"),
    small: "".concat(inputBase, "-small")
  },
  wrapper: {
    base: wrapperBase,
    hasPrefix: "".concat(wrapperBase, "-has_prefix"),
    hasPostfix: "".concat(wrapperBase, "-has_postfix")
  },
  affix: {
    base: affixBase,
    select: affixSelect
  }
};
exports.classes = classes;
var ErrorMessages = {
  missingIdOrName: 'LunaInput requires id or name to be provided, but received neither',
  missingAffixIdOrName: 'LunaInput Select Affix requires id or name to be provided, but received neither',
  missingOptions: 'LunaInput Select Affix requires options',
  nameEquivalence: 'Luna Select Affix name must be different than Luna Input name',
  controlledVUncontrolled: 'Luna Select Affix takes value or defaultValue, not both. Please refer to the docs about uncontrolled vs controlled components: https://fx-uitk.gitlabpages.nml.com/ui-toolkit-react/#!/LunaInput',
  missingInputValue: 'Luna Select Affix must have either value or defaultValue'
};
exports.ErrorMessages = ErrorMessages;
